import React from "react";
import { Button, Popover, Icon } from "orcs-design-system";
import PropTypes from "prop-types";

const SortIcon = ({ sortDsc, onClick, tooltip = "" }) => (
  <Popover
    width="200px"
    textAlign="center"
    direction="bottom"
    text={`${tooltip} (${sortDsc ? "descending" : "ascending"})`}
  >
    <Button
      variant="ghost"
      iconOnly
      height="25px"
      width="25px"
      mr="xs"
      onClick={onClick}
      small
      ariaLabel={`${tooltip} (${sortDsc ? "descending" : "ascending"})`}
    >
      <Icon
        icon={["fas", sortDsc ? "sort-amount-down-alt" : "sort-amount-up-alt"]}
      />
    </Button>
  </Popover>
);

SortIcon.propTypes = {
  onClick: PropTypes.func,
  sortDsc: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
};

export default SortIcon;
